import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, Messaging } from "firebase/messaging";
import axiosInstance from "./lib/api/axiosInstance";

// Firebase configuration from Vite environment variables
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Check if Firebase config is fully set up
const isFirebaseConfigured =
  firebaseConfig.apiKey &&
  firebaseConfig.projectId &&
  firebaseConfig.messagingSenderId &&
  firebaseConfig.appId;

let messaging: Messaging | null = null;

if (isFirebaseConfigured) {
  try {
    const app = initializeApp(firebaseConfig);
    messaging = getMessaging(app);
  } catch (error) {
    // ignore
  }
}

export const requestFirebaseToken = async (): Promise<string | null> => {
  if (!messaging) return null;

  try {
    // Request permission from the user
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      return null;
    }

    // Get the registration token
    const token = await getToken(messaging, {
      vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
    });

    if (token) {
      // Send token to the backend server to associate it with the current user account
      await axiosInstance.put(
        '/users/fcm-token',
        { token }
      );
      return token;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

export const registerOnMessage = (callback: (payload: any) => void) => {
  if (!messaging) return () => {};
  return onMessage(messaging, (payload) => {

    callback(payload);
  });
};
